import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useMemo } from "react";

import { useAppSelector } from "~/app/store";

import {
  selectPortStatus,
  selectPortHasBins,
  selectPortIsOpen,
  selectGridSystemMode
} from "~/features/andon/andon.selectors";
import { figureAndonColorFromStatus } from "~/features/andon/andon.utils";
import { useGetWorkstationsQuery } from "~/redux/warehouse/workstation.hooks";
type PortCardCompactViewProps = { portId: number };

export function PortCardCompactView({ portId }: PortCardCompactViewProps) {
  const portBinsSelector = useMemo(
    () => selectPortHasBins(portId.toString()),
    [portId]
  );

  const { data: workstations = [] } = useGetWorkstationsQuery();

  const hasBins = useAppSelector(portBinsSelector);

  const status = useAppSelector((state) =>
    selectPortStatus(portId?.toString())(state)
  );
  const isOpen = useAppSelector((state) =>
    selectPortIsOpen(portId?.toString())(state)
  );

  const parentWs = Object.values(workstations).find((ws) =>
    ws.ports.some((p) => p.portId === portId)
  );
  const gridId = parentWs?.autostoreGridId;

  const rawGridSystemMode = useAppSelector(selectGridSystemMode(gridId ?? ""));
  const gridSystemMode = rawGridSystemMode ?? undefined;

  const calculatedColors = figureAndonColorFromStatus({
    gridSystemMode,
    portStatus: status,
    portOpen: isOpen
  });
  return (
    <Box
      sx={{
        flex: "1 1 30%",
        maxWidth: "30%",
        height: 300,
        minWidth: 0,
        m: 0.5,
        p: 1,
        backgroundColor: calculatedColors.backgroundColor,
        border: "1px solid",
        borderColor: "black",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        boxSizing: "border-box"
      }}
    >
      <Typography variant="h6">{portId}</Typography>
      {hasBins.map((bin) => (
        <Box
          key={bin}
          sx={{
            width: "80%",
            mt: 1,
            p: 0.5,
            backgroundColor: "gray.main",
            textAlign: "center",
            borderRadius: 1
          }}
        >
          <Typography variant="body2">{bin}</Typography>
        </Box>
      ))}
    </Box>
  );
}

export default PortCardCompactView;
